import { render } from "./ImageCloning.vue?vue&type=template&id=51aabda0&scoped=true"
import script from "./ImageCloning.vue?vue&type=script&lang=js"
export * from "./ImageCloning.vue?vue&type=script&lang=js"

import "./ImageCloning.vue?vue&type=style&index=0&id=51aabda0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51aabda0"]])

export default __exports__